/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { memo, Fragment } from "react";
import Dialog from "@react/react-spectrum/Dialog";
import PropTypes from "prop-types";
import CommonDialogCss from "./CommonDialog.css";

function DialogWrapper(props) {
  const { Component, message, errCode } = props;
  return (
    <Dialog
      title={props.title}
      variant={props.variant}
      onConfirm={props.onConfirm}
      className={props.className}
      onCancel={props.onCancel}
      confirmLabel={props.confirmLabel}
      cancelLabel={props.cancelLabel}
      secondaryLabel={props.secondaryLabel}
      autoFocusButton={props.autoFocusButton}
      backdropClickable={props.backdropClickable}
      confirmDisabled={props.confirmDisabled}
    >
      {Component ? (
        <Component />
      ) : (
        <Fragment>
          <span>{message}</span>
          {errCode ? (
            <div className={CommonDialogCss.errCode}>
              Err_Code:&nbsp;<span>{errCode}</span>
            </div>
          ) : null}
        </Fragment>
      )}
    </Dialog>
  );
}

export default memo(DialogWrapper);

DialogWrapper.defaultProps = {
  onCancel: () => {},
  onConfirm: () => {},
  confirmLabel: "",
  cancelLabel: "",
  secondaryLabel: "",
  variant: "",
  autoFocusButton: "confirm",
  Component: null,
  message: "",
  errCode: "",
  backdropClickable: false,
  className: "",
  confirmDisabled: false
};

DialogWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  autoFocusButton: PropTypes.string,
  variant: PropTypes.string,
  errCode: PropTypes.string,
  Component: PropTypes.element,
  backdropClickable: PropTypes.bool,
  className: PropTypes.string,
  confirmDisabled: PropTypes.bool
};
